import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bce3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "ion-padding-vertical" }, "訂單待付款", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "ion-padding-vertical" }, "完成下單了！", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "您的訂單編號是：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 查看訂單詳情 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "信用卡付款失敗。", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 請盡快完成付款以確認訂單。 ")
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 如有任何查詢，可WhatsApp聯絡我們的客服："),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://wa.me/85252222989"
  }, "5222 2989")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_payment_info = _resolveComponent("payment-info")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, { class: "ion-text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_logo_img)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding ion-text-center" }, {
        default: _withCtx(() => [
          ($setup.orderStatus == '待付款' || $setup.paymentMethod == 'bank')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_ion_icon, {
                  class: "large-icon",
                  color: "warning",
                  icon: $setup.alertCircle
                }, null, 8, ["icon"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_ion_icon, {
                  class: "done-icon",
                  icon: $setup.checkmarkCircle
                }, null, 8, ["icon"])
              ])),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_5,
            _createVNode(_component_ion_text, { color: "primary" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString($setup.orderCode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              fill: "clear",
              expand: "block",
              style: {"font-size":"18px","color":"#333"},
              "router-link": {
          name: 'OrderDetailPage',
          params: { id: $setup.orderId, parentPath: '/orders' }
        }
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_ion_icon, {
                  slot: "end",
                  icon: $setup.chevronForward
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["router-link"])
          ], 512), [
            [_vShow, $setup.orderCode]
          ]),
          _hoisted_7,
          ($setup.orderStatus == '待付款' || $setup.paymentMethod == 'bank')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                ($setup.paymentMethod == 'card')
                  ? (_openBlock(), _createBlock(_component_ion_text, {
                      key: 0,
                      color: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_10
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, " 稍候您將會收到訂單確認訊息。 ")),
          _hoisted_12,
          _withDirectives(_createVNode(_component_payment_info, null, null, 512), [
            [_vShow, $setup.orderStatus == '待付款' || $setup.paymentMethod == 'bank']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}